import { render, staticRenderFns } from "./fuwuinfo.vue?vue&type=template&id=216f395c&scoped=true"
import script from "./fuwuinfo.vue?vue&type=script&lang=js"
export * from "./fuwuinfo.vue?vue&type=script&lang=js"
import style0 from "./fuwuinfo.vue?vue&type=style&index=0&id=216f395c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216f395c",
  null
  
)

export default component.exports